import React, { useEffect, useState } from "react";
// import headerlogo from "../../images/logo.svg";
import {ReactComponent as Headerlogo} from '../../images/logo.svg'
import "./header.css";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import { useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa6";
import { RxHamburgerMenu } from "react-icons/rx";
import { FaTimes } from "react-icons/fa";

const DropdownMenu = ({ title, items }) => (
  <li className="dropdownmainlink">
    <a role="button" style={{ cursor: "pointer" }}>
      {title} <FaChevronDown className="chevdown" />
    </a>
    <div className="linkdropdown">
      {items.map(({ color, label, link }, index) => (
        <div className="mobnavlikn" key={index}>
          <div className={`hexagon ${color}`}></div>
          <a href={link}>{label}</a>
        </div>
      ))}
    </div>
  </li>
);

const Header = () => {
  const [isMobMenuVisible, setIsMobMenuVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
  }, []);

  const toggleMobileMenu = () => {
    setIsMobMenuVisible((prev) => !prev);
  };

  const expertiseItems = [
    { color: "purple", label: "Augmented Reality", link: "https://arttteo.com/services/augmented-reality" },
    { color: "red", label: "Virtual Reality", link: "https://arttteo.com/services/virtual-reality" },
    { color: "violet", label: "Outsourcing", link: "https://arttteo.com/services/outsourcing" },
    { color: "lightblue", label: "Staff Augmentation", link: "https://arttteo.com/services/staff-augmentation" },
    { color: "orange", label: "AI and Machine Learning", link: "https://arttteo.com/services/machine-learning" },
  ];

  const servicesItems = [
    { color: "purple", label: "For Startup", link: "https://arttteo.com/expertise/for-startup" },
    { color: "lightblue", label: "For Agencies", link: "https://arttteo.com/expertise/for-investors" },
    { color: "orange", label: "For SME", link: "https://arttteo.com/expertise/for-programs" },
  ];

  return (
    <header data-aos="fade-down" data-aos-duration="700">
      <div className="logo">
        {/* <img
          src={headerlogo}
          alt="Header Logo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        /> */}
        <Headerlogo         alt="Header Logo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }} />
      </div>
      <nav className="header-links">
        <DropdownMenu title="Expertise" items={expertiseItems} />
        <li>
          <a href="https://arttteo.com/portfolios" style={{ cursor: "pointer" }}>
            Our Works
          </a>
        </li>
        <DropdownMenu title="Services" items={servicesItems} />
        <li>
          <a href="https://arttteo.com/blogs">Blog</a>
        </li>
        <li>
          <a href="https://arttteo.com/contact">Contact</a>
        </li>
      </nav>
      <button className="h-btn"><a href="https://arttteo.com/contact">Talk to us</a></button>
      {/* Mobile Menu Button */}
      <div
        className="mobnavmenubutton"
        onClick={toggleMobileMenu}
        style={{ cursor: "pointer" }}
      >
        {isMobMenuVisible ? <FaTimes /> : <RxHamburgerMenu />}
      </div>
      {/* Mobile Menu */}
      {isMobMenuVisible && (
        <div className={`mobnavmenu ${isMobMenuVisible ? "open" : "close"}`}>
          <DropdownMenu title="Expertise" items={expertiseItems} />
          <li>
            <a href="https://arttteo.com/portfolios">Our Works</a>
          </li>
          <DropdownMenu title="Services" items={servicesItems} />
          <li>
            <a href="https://arttteo.com/blogs">Blog</a>
          </li>
          <li>
            <a href="https://arttteo.com/contact">Contact</a>
          </li>
        </div>
      )}
    </header>
  );
};

export default Header;
